import React, {Component} from 'react';
import {Switch, Route, Router, Redirect} from 'react-router-dom';

import {history} from '../history';
import * as routes from '../constants/routes';

import Quiz from './Quiz/Quiz';
import Report from './Report/Report';
import SignInPage from "./Auth/SignIn/SignInPage";
import Account from "./Account/Account";
import TermsOfService from "./TermsOfService/TermsOfService";

import '../sharedStyles/global.css';

class App extends Component {

    render() {

        return (
            <Router history={history}>
                <Switch>
                    <Route path='/' exact component={Quiz} />

                    <Route path='/report' render={({location}) => <Report location={location}/>} />

                    <Route path={routes.SIGN_IN} render={({location}) => <SignInPage location={location}/>} />

                    <Route path={routes.ACCOUNT} render={({location}) => <Account location={location}/>} />

                    <Route path={routes.TERMS_OS} render={({location}) => <TermsOfService location={location}/>} />

                    <Redirect to="/" />
                </Switch>
            </Router>
        );

    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js